import { Configuration } from '@azure/msal-browser';

export const msalConfig: Configuration = {
  auth: {
    clientId: process.env.REACT_APP_ENTRA_CLIENT_ID!,
    authority: 'https://login.microsoftonline.com/common',
  },
};

export const graphScopes = [
  'https://graph.microsoft.com/User.Read',
  'https://graph.microsoft.com/User.ReadBasic.All',
  'https://graph.microsoft.com/Group.ReadWrite.All',
  'https://graph.microsoft.com/Sites.ReadWrite.All',
  'https://graph.microsoft.com/Calendars.ReadWrite',
  'https://graph.microsoft.com/OnlineMeetingTranscript.Read.All',
  // Required for Reports → Send Report, which posts to /me/sendMail.
  // Without this delegated scope the call returns 403.
  'https://graph.microsoft.com/Mail.Send',
  // Required for Automation Rules → Post to Channel, which lists
  // /me/joinedTeams. Group.ReadWrite.All is NOT accepted by that endpoint.
  'https://graph.microsoft.com/Team.ReadBasic.All',
];

// Dataverse scope is tenant-specific — read from env var, never hardcode.
export const dataverseScopes = [
  `${process.env.REACT_APP_DATAVERSE_URL}/user_impersonation`,
];
